var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23785 11.2202C4.94886 7.13968 8.46397 5 11.9855 5C16.1213 5 19.684 7.82921 21.786 11.2381L21.7869 11.2397C21.926 11.4666 22 11.7308 22 12.0007C22 12.27 21.9263 12.5337 21.7877 12.7604C19.6876 16.2132 16.1479 19 11.9855 19C7.7787 19 4.30729 16.219 2.21234 12.7763C2.06999 12.5442 1.99616 12.273 2.00015 11.997C2.00416 11.7202 2.0862 11.4509 2.2359 11.2231L2.23785 11.2202ZM3.33329 12.0183L3.33513 12.0213C5.2701 15.2017 8.37142 17.6 11.9855 17.6C15.559 17.6 18.7272 15.1916 20.6645 12.0061L20.6658 12.004C20.6664 12.003 20.6667 12.0018 20.6667 12.0007C20.6667 12.0002 20.6667 11.9997 20.6666 11.9992C20.6664 11.9986 20.6662 11.998 20.6659 11.9975C18.7212 8.84454 15.5271 6.4 11.9855 6.4C9.01301 6.4 5.86674 8.20652 3.33329 12.0183ZM11.9996 9.2C10.5269 9.2 9.33308 10.4536 9.33308 12C9.33308 13.5464 10.5269 14.8 11.9996 14.8C13.4723 14.8 14.6662 13.5464 14.6662 12C14.6662 10.4536 13.4723 9.2 11.9996 9.2ZM7.9998 12C7.9998 9.6804 9.79059 7.8 11.9996 7.8C14.2087 7.8 15.9995 9.6804 15.9995 12C15.9995 14.3196 14.2087 16.2 11.9996 16.2C9.79059 16.2 7.9998 14.3196 7.9998 12Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/showPassword.50579826f5423b8c1d53be4e37eb24aa.svg";
export { ForwardRef as ReactComponent };